import { observable, makeObservable } from 'mobx';
import { Runtime } from '../Runtime';
import { PersistWriteRequest } from '../../actor/persist/PersistWriteRequest';
import { Streamed } from '../../../types/types_model';
import { AnyPersistentActor } from '../../../types/types_entities';
import { Model } from '../../model/Model';

export class RuntimeSync {
  private readonly parent: Runtime;

  isJustSimulating: boolean = false;

  constructor(parent) {
    makeObservable(this);
    this.parent = parent;
  }

  get runtime() {
    return this.parent;
  }

  @observable.shallow syncronizedEntities = observable.map<string, Streamed<AnyPersistentActor>>();
  readonly entityFetchDeduplication = new Map<string, boolean>();

  addEntityToSyncronizedEntities(model: Model, entity: AnyPersistentActor) {
    const storeKey = `${model.id}_${model.owner.type}_${model.owner.id}_${entity.type}_${entity.id}`;
    this.syncronizedEntities.set(storeKey, entity);
  }

  @observable.shallow writeRequests = new Map<string, PersistWriteRequest | undefined>();

  get unObservedKeys(): string[] {
    return Array.from((this.syncronizedEntities as any)._hasMap.entries())
      .filter(e => !e[1].isBeingObserved)
      .map(e => e[0]);
  }
}
